exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3DZBaWBBYLNqDgwERiWv2F{padding-top:10px;padding-right:2px;display:flex;flex-direction:column;align-items:center;justify-content:center}::-webkit-input-placeholder{text-align:left}input:-moz-placeholder{text-align:left}", ""]);

// exports
exports.locals = {
	"ParkingDetailsContainer": "_3DZBaWBBYLNqDgwERiWv2F",
	"TagInput": "_5-f-05oFaIkHd6Q65BxTW"
};